import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Copyright = () => {
    return (
        <div className="copyright-area copyright-style-one">
            <div className='container'>
                <div className='row'>
                    <div className="col-12">
                        <img src="/images/payment.png" alt="Payment" className="w-100" />
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-8 col-sm-12 col-12">
                        <div className="copyright-left">
                            <ul className="ft-menu link-hover">
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/terms-and-condition">Terms And Condition</Link></li>
                                <li><Link to="/return-and-refund-policy">Return and Refund Policy</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                                <li><Link to="/about-us">About</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-4 col-sm-12 col-12">
                        <div className="copyright-right text-center text-md-end px-5">
                            <p className="copyright-text">© PWU {new Date().getFullYear()} <span> | Design By <a href='https://goodlysoft.com' target='_blank'><span className='text-success'>GoodlySoft</span></a></span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Copyright;